import React from 'react';
import styles from './AccessDenied.css';

// eslint-disable-next-line react/prop-types
const AccessDenied = ({ isSystemDown }) => (
  <div className={styles.container}>
    {!isSystemDown ? (
      <span>
        {`You do not have access to this application.
              Please contact the system administrator for additional details.`}
      </span>
    ) : (
      <div>
        <p>
          {'The Leads Assigner Portal is undergoing maintenance and will be down until July 1st at 8 a.m. CT.'}
          <br />
          {'Please check back again.'}
        </p>
        <p>
          {'El portal de Leads Assigner está en mantenimiento y estará inactivo hasta el 1 de julio a las 8 a.m. CT.'}
          <br />
          {'Por favor, vuelva a comprobarlo.'}
        </p>
      </div>
    )}
  </div>
);

export default AccessDenied;



// WEBPACK FOOTER //
// ./src/components/AccessDenied/AccessDenied.js